import { Card, Typography } from "@mui/material";
import React from "react";

const EmptyListWarning = () => {
  return (
    <Card
      width="100%"
      sx={{
        textAlign: "center",
        padding: 2,
        marginTop: 2,
      }}
    >
      <Typography fontWeight={600}>Nenhum resultado encontrado.</Typography>
    </Card>
  );
};

export default EmptyListWarning;
